<template>
  <div class="star-rating">
    <label
      class="star-rating__star"
      v-for="rating in ratings"
      :key="rating"
      :class="{
        'is-selected': value >= rating && value != null,
        'is-disabled': disabled,
      }"
      @click="set(rating)"
      @mouseover="star_over(rating)"
      @mouseout="star_out"
    >
      <input
        class="star-rating star-rating__checkbox"
        type="radio"
        :value="rating"
        :name="name"
        v-model="value"
        :disabled="disabled"
      />
      ★
    </label>
  </div>
</template>

<script>
export default {
  name: "rating",
  props: {
    name: String,
    value: null,
    id: String,
    disabled: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    required: Boolean,
  },
  data() {
    return {
      temp_value: null,
      ratings: [1, 2, 3, 4, 5],
    };
  },
  methods: {
    star_over(index) {
      const self = this;

      if (!this.disabled) {
        this.temp_value = this.value;
        return (this.value = index);
      }
    },

    star_out() {
      const self = this;

      if (!this.disabled) {
        return (this.value = this.temp_value);
      }
    },

    set(value) {
      const self = this;

      if (!this.disabled) {
        this.temp_value = value;
        return (this.value = value);
      }
    },
  },
};
</script>

<style lang="scss">
%visually-hidden {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  border: 0;
}

.star-rating {
  &__star {
    display: inline-block;
    padding: 3px;
    vertical-align: middle;
    line-height: 36px;
    font-size: 30px;
    color: #ababab;
    transition: color 0.2s ease-out;

    &:hover {
      cursor: pointer;
    }

    &.is-selected {
      color: #ffd700;
    }

    &.is-disabled:hover {
      cursor: default;
    }
  }

  &__checkbox {
    @extend %visually-hidden;
  }
}
</style>